import type { FunctionComponent } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import useJobFinanceOptionsProps from "components/job/JobLayout/JobFinanceOptions/useJobFinanceOptionsProps";

export interface JobFinanceOptionsProps {}

const JobFinanceOptions: FunctionComponent<JobFinanceOptionsProps> =
  function () {
    const { options, selected, isLoading } = useJobFinanceOptionsProps();

    return (
      <div className="flex flex-col">
        <Text
          text="Finance Options:"
          className="mb-2 text-20-24-em"
          isLoading={isLoading}
        />
        <div className="flex flex-row">
          <div className="flex min-w-32">
            <Text
              text="Attached rates:"
              className="mr-2 text-14-22-em"
              isLoading={isLoading}
            />
          </div>
          <div className="flex flex-col mb-1">
            {options ? (
              <>
                {options.map((option) => (
                  <Text
                    key={option.name}
                    text={[option.provider, option.name].join("-")}
                    className="text-14-22"
                    isLoading={isLoading}
                  />
                ))}
              </>
            ) : (
              <Text
                text="No rates added"
                className="text-14-22"
                isLoading={isLoading}
              />
            )}
          </div>
        </div>
        <div className="flex flex-row">
          <div className="flex min-w-32">
            <Text
              text="Selected rate:"
              className="mr-2 text-14-22-em"
              isLoading={isLoading}
            />
          </div>
          <div className="flex flex-col">
            <Text
              text={
                selected
                  ? [selected?.provider, selected?.name].join("-")
                  : "No rate selected"
              }
              className="text-14-22"
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    );
  };

export default JobFinanceOptions;
